import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@m/user/permissions'

const PROFILE_PREFIX = 'cabinet:info'
const p = (name: string) => PROFILE_PREFIX + ':' + name

export const SIMPLE_PAGE_DETAILS_VIEW_NAME = p('details-view')

const SimplePageDetailsView = () => import('./views/SimplePageDetail.vue')

const BASE_MODEL_NAME = 'info/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    route(
      ':slug/',
      SimplePageDetailsView,
      SIMPLE_PAGE_DETAILS_VIEW_NAME, //cabinet/info/{slug}/
      {
        meta: {
          title: () => $t('Текстова сторінка'),
        },
    }),
  ]
}

export { BASE_MODEL_NAME }